var _style, _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20, _defs21, _defs22, _defs23, _defs24, _defs25, _defs26, _defs27, _defs28, _defs29, _defs30, _defs31, _defs32, _defs33, _defs34, _defs35, _defs36, _defs37, _defs38, _defs39, _defs40, _defs41, _defs42, _defs43, _defs44, _defs45, _defs46, _defs47, _defs48, _defs49, _defs50, _defs51, _defs52, _defs53, _defs54, _defs55, _defs56, _defs57, _defs58, _defs59, _defs60, _defs61, _defs62, _defs63, _defs64, _defs65, _defs66, _defs67, _defs68, _defs69, _defs70, _defs71, _defs72, _defs73, _defs74, _defs75, _defs76, _defs77, _defs78, _defs79, _defs80, _defs81, _defs82, _defs83, _defs84, _defs85, _defs86, _defs87, _defs88, _defs89, _defs90, _defs91, _defs92, _defs93, _defs94, _defs95, _defs96, _defs97, _defs98, _defs99, _defs100, _defs101, _defs102, _defs103, _defs104, _defs105, _defs106, _defs107, _defs108, _defs109, _defs110, _defs111, _defs112, _defs113, _defs114, _defs115, _defs116, _defs117, _defs118, _defs119, _defs120, _defs121, _defs122, _defs123, _defs124, _defs125, _defs126, _defs127;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectionsHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 164",
    style: {
      enableBackground: "new 0 0 180 164"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{clip-path:url(#SVGID_00000166640921130812882900000005645335983819440549_);}\n\t.st2{clip-path:url(#SVGID_00000052817572872895089020000006009709096108196509_);}\n\t.st3{clip-path:url(#SVGID_00000163784452431705845440000007568763219784178858_);fill:#808080;}\n\t.st4{clip-path:url(#SVGID_00000101066983459215318720000008041879842769203100_);}\n\t.st5{clip-path:url(#SVGID_00000010297070380263878680000011438278293356024481_);}\n\t.st6{clip-path:url(#SVGID_00000026842502112020962480000002863510022709873081_);fill:#808080;}\n\t.st7{clip-path:url(#SVGID_00000105395109395070685130000015056762667193423027_);}\n\t.st8{clip-path:url(#SVGID_00000057139367550873153600000012571181652812040588_);}\n\t.st9{clip-path:url(#SVGID_00000155146812702598002570000010002791789819179703_);fill:#808080;}\n\t.st10{clip-path:url(#SVGID_00000042715373873608726130000015067554994597051541_);}\n\t.st11{clip-path:url(#SVGID_00000095307836641330368540000004250401357673926580_);}\n\t.st12{clip-path:url(#SVGID_00000133528165000662713820000017131424298195855520_);fill:#808080;}\n\t.st13{clip-path:url(#SVGID_00000159449306798905431070000007376462821350266808_);}\n\t.st14{clip-path:url(#SVGID_00000121280387260310788760000013770789625957273998_);}\n\t.st15{clip-path:url(#SVGID_00000116919534034598005640000006963077228562730681_);fill:#808080;}\n\t.st16{clip-path:url(#SVGID_00000181077743752300635820000002537327935083225534_);}\n\t.st17{clip-path:url(#SVGID_00000163059846189861502360000004071770669418456249_);}\n\t.st18{clip-path:url(#SVGID_00000132771264219698791190000006145694813430302878_);fill:#808080;}\n\t.st19{clip-path:url(#SVGID_00000183220941255806587990000006842698527200544415_);}\n\t.st20{clip-path:url(#SVGID_00000033371203743498089690000018353952938128886717_);}\n\t.st21{clip-path:url(#SVGID_00000108267061290016674180000017590975557531667613_);fill:#808080;}\n\t.st22{clip-path:url(#SVGID_00000057125530562954196330000005621802974906689427_);}\n\t.st23{clip-path:url(#SVGID_00000028291580933175850230000016701403882045995944_);}\n\t.st24{clip-path:url(#SVGID_00000041981689180130879170000002268944268904077711_);fill:#808080;}\n\t.st25{clip-path:url(#SVGID_00000152967507729844969890000006319481896343024801_);}\n\t.st26{clip-path:url(#SVGID_00000060027236739918103020000016759644955742037152_);}\n\t.st27{clip-path:url(#SVGID_00000165938721091755123010000013571202610184225165_);fill:#808080;}\n\t.st28{clip-path:url(#SVGID_00000143578596437617387820000017632300849397764273_);}\n\t.st29{clip-path:url(#SVGID_00000093160356140456311810000011093513815849138070_);}\n\t.st30{clip-path:url(#SVGID_00000036933517949943351670000000000543066796990111_);fill:#808080;}\n\t.st31{clip-path:url(#SVGID_00000023240022406571596310000007742348628365050775_);}\n\t.st32{clip-path:url(#SVGID_00000058555549421422247560000001366298330749308801_);}\n\t.st33{clip-path:url(#SVGID_00000044858097883913103010000000888054304795258002_);fill:#808080;}\n\t.st34{clip-path:url(#SVGID_00000064339923953468160970000003489590439238634387_);}\n\t.st35{clip-path:url(#SVGID_00000101801406937707263520000016568021802481453198_);}\n\t.st36{clip-path:url(#SVGID_00000108999072266222444220000005588159501361597837_);fill:#808080;}\n\t.st37{clip-path:url(#SVGID_00000008131285576984439870000004968595943479322553_);}\n\t.st38{clip-path:url(#SVGID_00000125598743562566526230000004815960288271947141_);}\n\t.st39{clip-path:url(#SVGID_00000128484409990336180230000013193950115903636111_);fill:#808080;}\n\t.st40{clip-path:url(#SVGID_00000026135100325216653840000009602737693418357694_);}\n\t.st41{clip-path:url(#SVGID_00000127013670509466197400000009613518057434740650_);}\n\t.st42{clip-path:url(#SVGID_00000004527662896428824670000000003376016010459037_);fill:#808080;}\n\t.st43{clip-path:url(#SVGID_00000031928289001372830690000009999133203660670373_);}\n\t.st44{clip-path:url(#SVGID_00000004531321848438307090000006909635066398112655_);}\n\t.st45{clip-path:url(#SVGID_00000072252072672968596470000002277238721393671325_);fill:#808080;}\n\t.st46{clip-path:url(#SVGID_00000092416919069252494100000003173119902259815811_);}\n\t.st47{clip-path:url(#SVGID_00000067920895163262801920000001619423075842237828_);}\n\t.st48{clip-path:url(#SVGID_00000042713831081451060620000012725056631236501937_);fill:#808080;}\n\t.st49{clip-path:url(#SVGID_00000131326027121852437570000009456704128107810967_);}\n\t.st50{clip-path:url(#SVGID_00000111886391082014362400000011172495952947931051_);}\n\t.st51{clip-path:url(#SVGID_00000155851234943150827380000006579698339237210540_);fill:#808080;}\n\t.st52{clip-path:url(#SVGID_00000059293559198262141200000002355253016838663610_);}\n\t.st53{clip-path:url(#SVGID_00000129170877136316038660000012871948660615945885_);}\n\t.st54{clip-path:url(#SVGID_00000159469613816166201460000009024428746907714694_);fill:#808080;}\n\t.st55{clip-path:url(#SVGID_00000070097536266779294760000010266872312330001291_);}\n\t.st56{clip-path:url(#SVGID_00000153705927256278969830000001715562569755170949_);}\n\t.st57{clip-path:url(#SVGID_00000034771055809493928250000005891533398841774523_);fill:#808080;}\n\t.st58{clip-path:url(#SVGID_00000103250999545368532250000017461426943060523176_);}\n\t.st59{clip-path:url(#SVGID_00000000225057233096731510000017264912521176729760_);}\n\t.st60{clip-path:url(#SVGID_00000162345936746965346630000001240337623912306085_);fill:#808080;}\n\t.st61{clip-path:url(#SVGID_00000047754128482177681110000006175157854465983656_);}\n\t.st62{clip-path:url(#SVGID_00000003826379018931721330000005886620958025602464_);}\n\t.st63{clip-path:url(#SVGID_00000023245521380248974650000012820664523404339892_);fill:#808080;}\n\t.st64{clip-path:url(#SVGID_00000070105759898840488490000002751119719365277312_);}\n\t.st65{clip-path:url(#SVGID_00000039843638625381950780000014965942742506915498_);}\n\t.st66{clip-path:url(#SVGID_00000048484982916268267450000006829410276988205749_);fill:#808080;}\n\t.st67{clip-path:url(#SVGID_00000091734125676639245950000006500628839821178787_);}\n\t.st68{clip-path:url(#SVGID_00000023985247715694693480000017989228595502732439_);}\n\t.st69{clip-path:url(#SVGID_00000110466891064517740430000012674023626625240197_);fill:#808080;}\n\t.st70{clip-path:url(#SVGID_00000127735606274977818300000013296762636129021358_);}\n\t.st71{clip-path:url(#SVGID_00000128446071283137117720000014256253357480850078_);}\n\t.st72{clip-path:url(#SVGID_00000170276398599485911300000017099835593862752175_);fill:#808080;}\n\t.st73{clip-path:url(#SVGID_00000032646779704738167800000009301190049615066542_);}\n\t.st74{clip-path:url(#SVGID_00000096738706905685131460000014266068032147216260_);}\n\t.st75{clip-path:url(#SVGID_00000052814602668908365410000009915990773193756856_);fill:#808080;}\n\t.st76{clip-path:url(#SVGID_00000044869622157959423930000002801853260066188425_);}\n\t.st77{clip-path:url(#SVGID_00000116916742401436705530000014293180562424932274_);}\n\t.st78{clip-path:url(#SVGID_00000132808867197888345090000007910320714429586875_);fill:#808080;}\n\t.st79{clip-path:url(#SVGID_00000091695704968234950860000016605177194483841444_);}\n\t.st80{clip-path:url(#SVGID_00000157285951112851199700000010305044399389446321_);}\n\t.st81{clip-path:url(#SVGID_00000066506054453855951230000016548489676167640980_);fill:#808080;}\n\t.st82{clip-path:url(#SVGID_00000035491990187927974260000005414523203867841689_);}\n\t.st83{clip-path:url(#SVGID_00000183971164349631413360000016404326577256695732_);}\n\t.st84{clip-path:url(#SVGID_00000105412496096159106970000008600338757963673241_);fill:#808080;}\n\t.st85{clip-path:url(#SVGID_00000031903008332918351370000011175339605057564593_);}\n\t.st86{clip-path:url(#SVGID_00000060731419003044254520000003566997921796186299_);}\n\t.st87{clip-path:url(#SVGID_00000086685214185313293290000010098049678266070200_);fill:#808080;}\n\t.st88{clip-path:url(#SVGID_00000150061832831171568710000010907616262230530450_);}\n\t.st89{clip-path:url(#SVGID_00000079460512706826652000000007935515570663557797_);}\n\t.st90{clip-path:url(#SVGID_00000081633145362989111080000001646156466306536346_);fill:#808080;}\n\t.st91{clip-path:url(#SVGID_00000125595410191546191310000012644420299501473705_);}\n\t.st92{clip-path:url(#SVGID_00000164507070018739667760000016722602022906364316_);}\n\t.st93{clip-path:url(#SVGID_00000001628752571723314530000016927675099851043490_);fill:#808080;}\n\t.st94{clip-path:url(#SVGID_00000093159289694560415990000000399492702813456276_);}\n\t.st95{clip-path:url(#SVGID_00000129926080723257181250000012843086329000432808_);}\n\t.st96{clip-path:url(#SVGID_00000009548095157780926540000017561359288603696802_);}\n\t.st97{clip-path:url(#SVGID_00000019660201113984741320000008397988200884873630_);fill:#808080;}\n\t.st98{clip-path:url(#SVGID_00000019674877522690329830000014937289537688675980_);}\n\t.st99{clip-path:url(#SVGID_00000138565602944932796380000011111609643495497139_);}\n\t.st100{clip-path:url(#SVGID_00000015353578414039678770000011494416462047455112_);}\n\t.st101{clip-path:url(#SVGID_00000048460194129115204470000004876343397400403377_);fill:#808080;}\n\t.st102{clip-path:url(#SVGID_00000103248800204689994470000004338037816171554193_);}\n\t.st103{clip-path:url(#SVGID_00000148658290775596719140000005021908835312892037_);}\n\t.st104{clip-path:url(#SVGID_00000183219606291297605450000010626510232564258690_);fill:#808080;}\n\t.st105{clip-path:url(#SVGID_00000010279609431518438280000004653405418588999048_);}\n\t.st106{clip-path:url(#SVGID_00000075140971838932860600000000172849978891964032_);}\n\t\n\t\t.st107{clip-path:url(#SVGID_00000020391088632034016340000000829555550229259942_);fill:none;stroke:#808080;stroke-width:2.5184;stroke-miterlimit:10;}\n\t.st108{clip-path:url(#SVGID_00000027598287214184331070000017735761854647700107_);}\n\t.st109{clip-path:url(#SVGID_00000049204784823794844010000004130228088182203038_);}\n\t\n\t\t.st110{clip-path:url(#SVGID_00000113312585076889248050000014885767703705840049_);fill:none;stroke:#808080;stroke-width:2.5184;stroke-miterlimit:10;}\n\t.st111{clip-path:url(#SVGID_00000085959496264141822580000011015988029366195639_);}\n\t.st112{clip-path:url(#SVGID_00000175282469354836508660000017582586643487724186_);}\n\t\n\t\t.st113{clip-path:url(#SVGID_00000014635277710477526600000000042901586358272669_);fill:none;stroke:#808080;stroke-width:2.5184;stroke-miterlimit:10;}\n\t.st114{clip-path:url(#SVGID_00000005235915077221855890000005072584426847337093_);}\n\t.st115{clip-path:url(#SVGID_00000062914248891414726100000006411966084271211161_);}\n\t\n\t\t.st116{clip-path:url(#SVGID_00000082349213401702408070000005281473454739720379_);fill:none;stroke:#808080;stroke-width:2.5184;stroke-miterlimit:10;}\n\t.st117{clip-path:url(#SVGID_00000141433911900334484450000012063197643687039397_);}\n\t.st118{clip-path:url(#SVGID_00000096042039457982176710000008770024059635521688_);}\n\t\n\t\t.st119{clip-path:url(#SVGID_00000026162372262441748310000016061958264788515991_);fill:none;stroke:#808080;stroke-width:2.5184;stroke-miterlimit:10;}\n\t.st120{opacity:0.5;}\n\t.st121{clip-path:url(#SVGID_00000076573663912518864730000005336910631134602112_);}\n\t.st122{clip-path:url(#SVGID_00000063635853078061338590000006778014255750468014_);}\n\t.st123{clip-path:url(#SVGID_00000036226557199722732480000000215998360944217729_);fill:#808080;}\n")), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 183,
    height: 166,
    xlinkHref: "99774463858B8B4.png",
    transform: "matrix(0.9943 0 0 0.9943 -1.0678 -0.1814)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.1,
    y: -0.2,
    className: "st0",
    width: 182,
    height: 165
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011723000793944488760000012645422949017488814_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011723000793944488760000012645422949017488814_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000164500187234648565470000016975128655752448134_",
    d: "M28.7,70.9h9.4c0.1-0.5,0.2-1.1,0.4-1.6h-9.7"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095339529466948224760000002138386453209654931_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164500187234648565470000016975128655752448134_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095339529466948224760000002138386453209654931_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000111164102349446580980000016962782954120803204_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165212425980275857980000010635270833909872287_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111164102349446580980000016962782954120803204_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.7,
    y: 68.3,
    style: {
      clipPath: "url(#SVGID_00000165212425980275857980000010635270833909872287_)",
      fill: "#808080"
    },
    width: 11.7,
    height: 3.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160897778122106575690000001486800958040419717_",
    x: 1.3,
    y: 41.9,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080166955711893019970000001863727328240446091_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160897778122106575690000001486800958040419717_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080166955711893019970000001863727328240446091_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000164489750507431360830000006175239906203494313_",
    d: "M143.5,125.8H121c-0.1,0.5-1.3,1.1-1.5,1.6 h23.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000133526520502053424940000011200111469935845559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000164489750507431360830000006175239906203494313_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000133526520502053424940000011200111469935845559_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000149354288217216224960000014577818117579579299_",
    x: -7.7,
    y: 31.9,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156564005636469421530000012739498099523156400_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000149354288217216224960000014577818117579579299_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000156564005636469421530000012739498099523156400_)",
      fill: "#808080"
    },
    points: " 144.5,128.4 119.7,128.4 118.7,124.8 144.5,124.8  "
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060007649116259707340000004012093382397504136_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000115494712679970990530000016010433613853577111_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060007649116259707340000004012093382397504136_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000115494712679970990530000016010433613853577111_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000136380487573286212420000018061864715562488453_",
    d: "M28.2,69.4l0.1,0.5h9.5c0,0.2-0.1,0.4-0.1,0.5 h-9.4l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152232709192515126690000011964682708772090554_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136380487573286212420000018061864715562488453_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152232709192515126690000011964682708772090554_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000179616107681348270180000011938511873562451599_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181805851610643088370000003155696445567288241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000179616107681348270180000011938511873562451599_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 27.2,
    y: 68.4,
    style: {
      clipPath: "url(#SVGID_00000181805851610643088370000003155696445567288241_)",
      fill: "#808080"
    },
    width: 11.6,
    height: 3.4
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000121257807157082519940000016605488863670494089_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075879608950454493760000012323757934578868894_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121257807157082519940000016605488863670494089_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075879608950454493760000012323757934578868894_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000128446475727948727780000015967108079430100921_",
    d: "M150.6,69.3h-9.7c0.1,0.5,0.2,1.1,0.4,1.6h9.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006694916898631598420000007749948000740970902_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128446475727948727780000015967108079430100921_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006694916898631598420000007749948000740970902_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065040625113006512710000012343348784300594086_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088102291049140024130000000144763386109857968_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065040625113006512710000012343348784300594086_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 139.9,
    y: 68.3,
    style: {
      clipPath: "url(#SVGID_00000088102291049140024130000000144763386109857968_)",
      fill: "#808080"
    },
    width: 11.7,
    height: 3.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065073791358552729180000011217623143040237712_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156582377294436723860000001841832934928624308_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065073791358552729180000011217623143040237712_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000156582377294436723860000001841832934928624308_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139269368086794062550000012729237321893106101_",
    d: "M151.1,70.9l-0.1-0.5h-9.4 c0-0.2-0.1-0.4-0.1-0.5h9.5l0.1-0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129188927626188487550000009681992677596434830_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139269368086794062550000012729237321893106101_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129188927626188487550000009681992677596434830_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090262995729057750900000004929576834294104471_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033352716626121746380000000326322003377435534_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090262995729057750900000004929576834294104471_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 140.5,
    y: 68.4,
    style: {
      clipPath: "url(#SVGID_00000033352716626121746380000000326322003377435534_)",
      fill: "#808080"
    },
    width: 11.6,
    height: 3.4
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154398206920942983300000000578355240973096091_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158013684773555198150000015300076694163464363_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154398206920942983300000000578355240973096091_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158013684773555198150000015300076694163464363_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000127014954915375690220000008519329936337292474_",
    d: "M22.3,101.2h18c-0.2-0.5-0.4-1.1-0.6-1.6H22.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144301344111013096800000000836716050430483868_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127014954915375690220000008519329936337292474_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000144301344111013096800000000836716050430483868_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060712462823099175110000015573676845839882411_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000108271608601646175600000000531454108435859613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060712462823099175110000015573676845839882411_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 21.3,
    y: 98.6,
    style: {
      clipPath: "url(#SVGID_00000108271608601646175600000000531454108435859613_)",
      fill: "#808080"
    },
    width: 20,
    height: 3.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000078029585640795563580000010823196488368554660_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178886587198462371620000006260452231055681408_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078029585640795563580000010823196488368554660_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000178886587198462371620000006260452231055681408_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000139988352508132335270000003187671531862950829_",
    d: "M21.7,99.7l0.1,0.5h17.5 c0.1,0.2,0.1,0.4,0.2,0.5H21.9l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053521866045951408520000010408572678386787209_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139988352508132335270000003187671531862950829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000053521866045951408520000010408572678386787209_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000131366560278626380070000009563337671737012888_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042703786163712333030000004030568421771549365_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000131366560278626380070000009563337671737012888_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 20.7,
    y: 98.7,
    style: {
      clipPath: "url(#SVGID_00000042703786163712333030000004030568421771549365_)",
      fill: "#808080"
    },
    width: 19.7,
    height: 3.5
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005977521409843755850000006487743831490367881_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101077324829912059640000001975962693977389494_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005977521409843755850000006487743831490367881_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101077324829912059640000001975962693977389494_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067932489666094474450000007213891389049859746_",
    d: "M155.9,99.6h-16.3c-0.2,0.5-0.4,1.1-0.6,1.6 h16.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000011018053800924896160000002510044156488614314_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067932489666094474450000007213891389049859746_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000011018053800924896160000002510044156488614314_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000013896466595831321830000014796117737032006285_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111162184549269299950000014012178970742371457_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000013896466595831321830000014796117737032006285_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.1,
    y: 98.6,
    style: {
      clipPath: "url(#SVGID_00000111162184549269299950000014012178970742371457_)",
      fill: "#808080"
    },
    width: 18.9,
    height: 3.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160870206637734761830000013379922228337490569_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000061470471790474107140000001932387526647789704_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160870206637734761830000013379922228337490569_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000061470471790474107140000001932387526647789704_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000112628780291234844800000007904052178185145780_",
    d: "M156.4,101.1l-0.1-0.5h-16.6 c0.1-0.2,0.1-0.4,0.2-0.5h16.4l0.1-0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059306333622578732700000010603525724446473130_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112628780291234844800000007904052178185145780_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000059306333622578732700000010603525724446473130_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000154388927071300044380000008445181996586309522_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063591546693000810960000008447108239146464679_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154388927071300044380000008445181996586309522_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.8,
    y: 98.7,
    style: {
      clipPath: "url(#SVGID_00000063591546693000810960000008447108239146464679_)",
      fill: "#808080"
    },
    width: 18.6,
    height: 3.5
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163072257311323684740000017093632819426487225_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023961717834723143690000016631543213612825233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163072257311323684740000017093632819426487225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023961717834723143690000016631543213612825233_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000115489373751356542270000015679726467252715908_",
    d: "M63.3,17.5H75v14c0.5-0.2,1.1-0.3,1.6-0.4V16.7 c0-0.4-0.4-0.8-0.8-0.8H63.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031887447357805367340000014571261306231309453_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000115489373751356542270000015679726467252715908_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031887447357805367340000014571261306231309453_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000022538111953656816460000013543448746247275956_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050639802226998319260000001434796249094621056_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022538111953656816460000013543448746247275956_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.3,
    y: 14.9,
    style: {
      clipPath: "url(#SVGID_00000050639802226998319260000001434796249094621056_)",
      fill: "#808080"
    },
    width: 15.3,
    height: 17.7
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060715189074583519380000004935430510088707715_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000050640420366840593230000003879704535658861467_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060715189074583519380000004935430510088707715_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000050640420366840593230000003879704535658861467_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000129890967446770055930000013138990258042114970_",
    d: "M62.9,15.9v0.5h12.9c0.1,0,0.3,0.1,0.3,0.3v14 c-0.2,0-0.4,0.1-0.5,0.1V17H62.9l-0.1,0.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176749170072935149860000001984762395381210758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129890967446770055930000013138990258042114970_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176749170072935149860000001984762395381210758_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155841050858042814950000015077486842311626940_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047051945547517472940000011846776297121561233_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155841050858042814950000015077486842311626940_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.8,
    y: 14.9,
    style: {
      clipPath: "url(#SVGID_00000047051945547517472940000011846776297121561233_)",
      fill: "#808080"
    },
    width: 15.3,
    height: 16.9
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000075134105923600108600000010020712745037979777_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025434422092008176820000013374323715650748806_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000075134105923600108600000010020712745037979777_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000025434422092008176820000013374323715650748806_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060729344446930651870000004529136203858945691_",
    d: "M76.6,148v-14.2c-0.5-0.1-1.1-0.3-1.6-0.4v13.9 H50.4c-0.5-3.1-3.2-5.4-6.4-5.4v1.6c2.7,0,4.9,2.2,4.9,4.9s-2.2,4.9-4.9,4.9s-4.9-2.2-4.9-4.9h-1.6 c0,3.6,2.9,6.5,6.5,6.5c3.4,0,6.3-2.7,6.5-6.1h25.3C76.3,148.8,76.6,148.4,76.6,148"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000125599897216415651930000017336810090198488981_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060729344446930651870000004529136203858945691_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000125599897216415651930000017336810090198488981_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000070807201881080476570000016728339334039054002_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137815177009420093950000016521622555307385735_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000070807201881080476570000016728339334039054002_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 132.3,
    style: {
      clipPath: "url(#SVGID_00000137815177009420093950000016521622555307385735_)",
      fill: "#808080"
    },
    width: 41.1,
    height: 23.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171715841408119601800000004764410940744717759_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181784886567466482980000001232969003759785133_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171715841408119601800000004764410940744717759_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000181784886567466482980000001232969003759785133_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000176022824251417089750000013354202668583680392_",
    d: "M44,154.3c-3.1,0-5.7-2.4-6-5.4h0.5 c0.3,2.8,2.6,4.9,5.4,4.9c3,0,5.5-2.5,5.5-5.5c0-2.8-2.2-5.2-4.9-5.4v-0.5c2.7,0.2,4.9,2.2,5.3,4.9l0.1,0.5h25.6V134 c0.2,0,0.4,0.1,0.5,0.1V148c0,0.1-0.1,0.3-0.3,0.3H49.9v0.5C49.8,151.9,47.2,154.3,44,154.3"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137122732841125806460000004966460401568363656_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176022824251417089750000013354202668583680392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137122732841125806460000004966460401568363656_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000083066696449346768850000015198782531972138408_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000090996173451721958220000007215539342517194169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000083066696449346768850000015198782531972138408_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.1,
    y: 133,
    style: {
      clipPath: "url(#SVGID_00000090996173451721958220000007215539342517194169_)",
      fill: "#808080"
    },
    width: 40,
    height: 22.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000080174321622992105420000014508177277489691267_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057836922999694269430000007116187012619452824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080174321622992105420000014508177277489691267_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057836922999694269430000007116187012619452824_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168083303131524669560000011023632123213289379_",
    d: "M103.7,147.1v-13.7c-0.5,0.1-1.1,0.3-1.6,0.4 V148c0,0.4,0.4,0.8,0.8,0.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000028298762381312138820000010209717760048765069_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168083303131524669560000011023632123213289379_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000028298762381312138820000010209717760048765069_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000093159190164312145930000018120938607632122018_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129887889280351351290000006350944000923490954_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093159190164312145930000018120938607632122018_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 132.4,
    style: {
      clipPath: "url(#SVGID_00000129887889280351351290000006350944000923490954_)",
      fill: "#808080"
    },
    width: 3.6,
    height: 17.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000008861058358498610000000016584928679051298960_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088822135404409022720000015142231093662719633_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008861058358498610000000016584928679051298960_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088822135404409022720000015142231093662719633_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000108998854933464267720000008821197444616573357_",
    d: "M102.9,148.2c-0.1,0-0.3-0.1-0.3-0.3v-13.7 c0.2,0,0.3-0.1,0.5-0.1v13.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140008203954441452480000005866814130683696774_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108998854933464267720000008821197444616573357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000140008203954441452480000005866814130683696774_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000116215874522230348930000013912890916477587135_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052088308170814183710000002988468230524111770_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116215874522230348930000013912890916477587135_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.7,
    y: 133.1,
    style: {
      clipPath: "url(#SVGID_00000052088308170814183710000002988468230524111770_)",
      fill: "#808080"
    },
    width: 2.5,
    height: 16.1
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000060722296185094367700000018342292687100394674_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176028241022774717180000016170922794556132762_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060722296185094367700000018342292687100394674_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176028241022774717180000016170922794556132762_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005250389735820260690000004578310181880661949_",
    d: "M103.7,17.5h24.6c0.5,3.1,3.2,5.4,6.4,5.4 c3.6,0,6.5-2.9,6.5-6.5h-1.6c0,2.7-2.2,4.9-4.9,4.9s-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9V9.9c-3.4,0-6.3,2.7-6.5,6.1h-25.3 c-0.4,0-0.8,0.4-0.8,0.8V31c0.5,0.1,1.1,0.3,1.6,0.4L103.7,17.5L103.7,17.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049905491903925203940000002064038577220622209_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005250389735820260690000004578310181880661949_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000049905491903925203940000002064038577220622209_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000021830513479363178520000011209690798287232422_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000049208093007919190560000012924850431836276900_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021830513479363178520000011209690798287232422_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.1,
    y: 8.8,
    style: {
      clipPath: "url(#SVGID_00000049208093007919190560000012924850431836276900_)",
      fill: "#808080"
    },
    width: 41.1,
    height: 23.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054981070268044377500000002223766135269093814_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057147822250876453070000016230437955448764551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054981070268044377500000002223766135269093814_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057147822250876453070000016230437955448764551_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000134939606462913409020000011748934169885085060_",
    d: "M102.7,30.6V16.7c0-0.1,0.1-0.3,0.3-0.3h25.8 v-0.5c0.2-2.9,2.5-5.3,5.4-5.5v0.5c-2.8,0.3-4.9,2.6-4.9,5.4c0,3,2.5,5.5,5.5,5.5c2.8,0,5.2-2.2,5.4-4.9h0.5 c-0.3,3.1-2.8,5.4-6,5.4c-2.9,0-5.4-2.1-5.9-4.9l-0.1-0.5h-25.6v13.7C103,30.7,102.8,30.6,102.7,30.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013871565384127834920000013446624708233415087_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000134939606462913409020000011748934169885085060_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013871565384127834920000013446624708233415087_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000139981623972611265030000008080645335542850990_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080182470115337334700000006637479231832105398_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000139981623972611265030000008080645335542850990_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 101.7,
    y: 9.4,
    style: {
      clipPath: "url(#SVGID_00000080182470115337334700000006637479231832105398_)",
      fill: "#808080"
    },
    width: 40,
    height: 22.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036220030994957526080000000734202433853938364_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000054225957076614401600000000330595183419145150_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036220030994957526080000000734202433853938364_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000054225957076614401600000000330595183419145150_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000035513232476611986700000010315872035483274430_",
    d: "M137.5,82.4c0-26.4-21.5-47.9-47.8-47.9 c-26.4,0-47.8,21.5-47.8,47.9s21.5,47.9,47.8,47.9S137.5,108.8,137.5,82.4 M43.7,82.4c0-25.3,20.6-46,45.9-46 s45.9,20.6,45.9,46s-20.6,46-45.9,46S43.7,107.8,43.7,82.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044153891398742541230000002291608788819605658_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035513232476611986700000010315872035483274430_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044153891398742541230000002291608788819605658_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000100350103140060775430000003153403094992614551_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041296706020743828920000011706212800512661930_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100350103140060775430000003153403094992614551_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 40.8,
    y: 33.5,
    style: {
      clipPath: "url(#SVGID_00000041296706020743828920000011706212800512661930_)",
      fill: "#808080"
    },
    width: 97.7,
    height: 97.8
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000143607752453294335600000009509875956509862554_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000147899480816659919300000009977109305101312660_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143607752453294335600000009509875956509862554_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000147899480816659919300000009977109305101312660_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078010076546324507420000011954880089804056241_",
    d: "M89.6,129.8c-26.1,0-47.3-21.2-47.3-47.4 C42.3,56.3,63.5,35,89.6,35s47.3,21.2,47.3,47.4C136.9,108.5,115.7,129.8,89.6,129.8 M89.6,35.9 c-25.6,0-46.5,20.9-46.5,46.5s20.8,46.5,46.5,46.5s46.5-20.9,46.5-46.5S115.3,35.9,89.6,35.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003795968268324474230000015031118349722004392_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078010076546324507420000011954880089804056241_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003795968268324474230000015031118349722004392_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000002381393041000140640000013024534331014418054_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132087998645920527650000013805897343657989258_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000002381393041000140640000013024534331014418054_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 34.1,
    style: {
      clipPath: "url(#SVGID_00000132087998645920527650000013805897343657989258_)",
      fill: "#808080"
    },
    width: 96.6,
    height: 96.7
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000125597953760561726000000004620586367661803397_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026850655718363785900000011454911347265451709_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000125597953760561726000000004620586367661803397_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026850655718363785900000011454911347265451709_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000100367731481385027060000009841498467948240523_",
    d: "M99.2,27.9l0.2-1.3c-6.6-1.1-13.5-1.1-20.1,0.1 l0.2,1.3C86,26.8,92.7,26.8,99.2,27.9"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004537432975568241360000007709017836189205915_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100367731481385027060000009841498467948240523_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004537432975568241360000007709017836189205915_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005265388828825276490000003113288443243678387_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000181792065536564416880000013594581978495161744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005265388828825276490000003113288443243678387_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.3,
    y: 24.5,
    style: {
      clipPath: "url(#SVGID_00000181792065536564416880000013594581978495161744_)",
      fill: "#808080"
    },
    width: 22.1,
    height: 4.5
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000174560436075299323110000008400160458221394320_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164506615428440187630000002196448666176977280_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174560436075299323110000008400160458221394320_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000164506615428440187630000002196448666176977280_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000000939851286402979140000004080608325101075848_",
    d: "M79.9,27.2c3.2-0.6,6.4-0.8,9.7-0.8 c3.1,0,6.1,0.2,9.1,0.7v0.2c-3-0.5-6-0.7-9.1-0.7c-3.3,0-6.5,0.3-9.7,0.8V27.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000030454178830656810070000008591356855130348448_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000000939851286402979140000004080608325101075848_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000030454178830656810070000008591356855130348448_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127750590388986362270000015000254655786499225_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042715129772199489460000010184754490736377524_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127750590388986362270000015000254655786499225_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 78.9,
    y: 25.3,
    style: {
      clipPath: "url(#SVGID_00000042715129772199489460000010184754490736377524_)",
      fill: "#808080"
    },
    width: 20.9,
    height: 3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000032633792865154732050000017395393416592144783_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000153681241274689851050000000658361795980176058_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032633792865154732050000017395393416592144783_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000153681241274689851050000000658361795980176058_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000118373688057187400240000001368802024326098561_",
    d: "M71.2,30.2L70.8,29 c-16.1,5.7-29,18.7-34.6,34.9l1.2,0.4C42.8,48.5,55.4,35.8,71.2,30.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079461254500947605440000004414136719991459748_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000118373688057187400240000001368802024326098561_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000079461254500947605440000004414136719991459748_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160894455988962527700000009206396525493863604_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159430231254963096120000002230206314318837892_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160894455988962527700000009206396525493863604_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.1,
    y: 28,
    style: {
      clipPath: "url(#SVGID_00000159430231254963096120000002230206314318837892_)",
      fill: "#808080"
    },
    width: 37,
    height: 37.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000032625633901168390610000001659668958342763407_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145767376751354469380000012306981602729311661_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000032625633901168390610000001659668958342763407_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145767376751354469380000012306981602729311661_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000063628927594032905000000008931787278127047088_",
    d: "M36.8,63.6c5.6-15.6,18-28.2,33.6-33.9l0.1,0.2 C55,35.6,42.6,48.1,37.1,63.6H36.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106143018487384833890000012165170435553697666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063628927594032905000000008931787278127047088_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106143018487384833890000012165170435553697666_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000063612320970180370550000007544463742499683969_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000127039150111893086390000016535126786784380606_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063612320970180370550000007544463742499683969_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.8,
    y: 28.7,
    style: {
      clipPath: "url(#SVGID_00000127039150111893086390000016535126786784380606_)",
      fill: "#808080"
    },
    width: 35.6,
    height: 35.9
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000039121227836003739900000016226491035820430469_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034050348357587133750000009782744032509095329_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039121227836003739900000016226491035820430469_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034050348357587133750000009782744032509095329_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000096053754535491161770000009618881361464425625_",
    d: "M33.5,75.3c-0.3,2.3-0.4,4.7-0.4,7.1 c0,4.5,0.5,8.9,1.6,13.2l1.3-0.3c-1-4.2-1.5-8.6-1.5-12.9c0-2.3,0.1-4.7,0.4-7L33.5,75.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093869712917280233310000013771475491361469079_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096053754535491161770000009618881361464425625_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093869712917280233310000013771475491361469079_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000005958458067404308750000009179634894334254236_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003795773585161000290000017502318116351614626_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005958458067404308750000009179634894334254236_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 74.3,
    style: {
      clipPath: "url(#SVGID_00000003795773585161000290000017502318116351614626_)",
      fill: "#808080"
    },
    width: 4.8,
    height: 22.4
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000069396813275119527020000012700898535609587616_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000077295993752836064540000003536472326840473787_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069396813275119527020000012700898535609587616_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000077295993752836064540000003536472326840473787_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000152947828416955384640000002023332662980871593_",
    d: "M35,95c-0.9-4.1-1.4-8.3-1.4-12.6 c0-2.2,0.1-4.4,0.4-6.5h0.2c-0.2,2.1-0.4,4.3-0.4,6.5c0,4.2,0.5,8.5,1.4,12.5L35,95z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000020396030634481583960000003922415378367664564_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152947828416955384640000002023332662980871593_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000020396030634481583960000003922415378367664564_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127766719117264898890000001503799772925963917_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005948575001400939360000000884084227627355065_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127766719117264898890000001503799772925963917_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.6,
    y: 74.9,
    style: {
      clipPath: "url(#SVGID_00000005948575001400939360000000884084227627355065_)",
      fill: "#808080"
    },
    width: 3.6,
    height: 21.1
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000102518416551324857650000000151745727512360593_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106837613519616914420000013521125247546068906_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102518416551324857650000000151745727512360593_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106837613519616914420000013521125247546068906_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000072996150715273570640000016498521461309707692_",
    d: "M69.4,135.4l0.5-1.2 c-13.3-5.1-24.4-15.5-30.4-28.4l-1.2,0.5C44.4,119.5,55.8,130.1,69.4,135.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006675359227585174760000012930182467104056500_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072996150715273570640000016498521461309707692_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006675359227585174760000012930182467104056500_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000065044054709313185640000015667299560814910891_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152227245395084529760000000712335999935371176_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000065044054709313185640000015667299560814910891_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 104.7,
    style: {
      clipPath: "url(#SVGID_00000152227245395084529760000000712335999935371176_)",
      fill: "#808080"
    },
    width: 33.6,
    height: 31.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076601118348702236850000013134404944575615616_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160157333931710211010000010257793103796339864_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076601118348702236850000013134404944575615616_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160157333931710211010000010257793103796339864_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000008131665935488664270000006124432672499841436_",
    d: "M69.1,134.7c-13.1-5.2-24-15.4-30.1-28.1 l0.2-0.1c6,12.7,16.9,22.9,30,28L69.1,134.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000160909363466527828770000003635564515932519567_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000008131665935488664270000006124432672499841436_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000160909363466527828770000003635564515932519567_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs81 || (_defs81 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000177474987949274203310000010380893437600201862_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000140701793215218876320000016917335226841950632_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000177474987949274203310000010380893437600201862_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 105.4,
    style: {
      clipPath: "url(#SVGID_00000140701793215218876320000016917335226841950632_)",
      fill: "#808080"
    },
    width: 32.2,
    height: 30.2
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs82 || (_defs82 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173160637173274469450000015434106253595348140_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031203305047466743020000009828068739348581511_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173160637173274469450000015434106253595348140_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031203305047466743020000009828068739348581511_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs83 || (_defs83 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123424121063837106200000003629743704896648878_",
    d: "M108.3,29l-0.4,1.2 c15.7,5.6,28.4,18.3,33.8,34.1l1.2-0.4C137.3,47.8,124.4,34.7,108.3,29"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138559036787617692560000009845887931010949764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123424121063837106200000003629743704896648878_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000138559036787617692560000009845887931010949764_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs84 || (_defs84 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000163045210976506112220000002313903484395127461_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033350269819333841900000017081330193716910521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000163045210976506112220000002313903484395127461_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.9,
    y: 28,
    style: {
      clipPath: "url(#SVGID_00000033350269819333841900000017081330193716910521_)",
      fill: "#808080"
    },
    width: 37,
    height: 37.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs85 || (_defs85 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031925439828840121850000006043295887129635766_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025413779903320321390000006278478839775094690_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031925439828840121850000006043295887129635766_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000025413779903320321390000006278478839775094690_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs86 || (_defs86 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000122705190326814104520000005418906049034515630_",
    d: "M142,63.6c-5.5-15.5-18-28.1-33.4-33.7l0.1-0.2 c15.5,5.7,28,18.3,33.6,33.9H142z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044179731968691736020000016459211820442984362_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000122705190326814104520000005418906049034515630_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000044179731968691736020000016459211820442984362_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs87 || (_defs87 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000091703128728532750840000016301805630921123498_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121247751544443007660000005524922526684795542_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091703128728532750840000016301805630921123498_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 107.6,
    y: 28.7,
    style: {
      clipPath: "url(#SVGID_00000121247751544443007660000005524922526684795542_)",
      fill: "#808080"
    },
    width: 35.6,
    height: 35.9
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs88 || (_defs88 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000091013815130535416120000009763762785556039867_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106106480718006769280000014572464887546428340_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000091013815130535416120000009763762785556039867_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106106480718006769280000014572464887546428340_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs89 || (_defs89 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106831620225196305680000003382696737769000638_",
    d: "M144.4,95.7c1-4.3,1.6-8.8,1.6-13.2 c0-2.4-0.2-4.8-0.4-7.1l-1.3,0.2c0.3,2.3,0.4,4.6,0.4,7c0,4.4-0.5,8.7-1.5,12.9L144.4,95.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000107546425270724932830000017433274951157520772_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106831620225196305680000003382696737769000638_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000107546425270724932830000017433274951157520772_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs90 || (_defs90 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000019644332114630955390000001293409930276638115_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119820674926883389380000010116376299790797205_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019644332114630955390000001293409930276638115_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142.2,
    y: 74.3,
    style: {
      clipPath: "url(#SVGID_00000119820674926883389380000010116376299790797205_)",
      fill: "#808080"
    },
    width: 4.8,
    height: 22.4
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs91 || (_defs91 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000102515619930609049560000003893144386680282815_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183950374834571126820000001970167224907466676_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000102515619930609049560000003893144386680282815_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183950374834571126820000001970167224907466676_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs92 || (_defs92 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000021113284277531581030000007071701313790516357_",
    d: "M143.8,95c0.9-4.1,1.4-8.3,1.4-12.5 c0-2.2-0.1-4.3-0.4-6.5h0.2c0.2,2.1,0.4,4.3,0.4,6.5c0,4.2-0.5,8.5-1.4,12.6L143.8,95z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068655975908306025810000001490503122184333480_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000021113284277531581030000007071701313790516357_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000068655975908306025810000001490503122184333480_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs93 || (_defs93 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000025419102431975978990000004018177097951039935_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039092995135857570880000013592525026092284065_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000025419102431975978990000004018177097951039935_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142.8,
    y: 74.9,
    style: {
      clipPath: "url(#SVGID_00000039092995135857570880000013592525026092284065_)",
      fill: "#808080"
    },
    width: 3.6,
    height: 21.1
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs94 || (_defs94 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000152224230901074115010000015904382267813416592_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118375807031546554170000000331205441747770295_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000152224230901074115010000015904382267813416592_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118375807031546554170000000331205441747770295_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs95 || (_defs95 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052800057820048715140000006585045838434577840_",
    d: "M109.1,134.2l0.5,1.2c2.8-1.1,5.5-2.4,8.1-3.9 l-0.7-1.1C114.5,131.9,111.8,133.2,109.1,134.2"
  }))), _defs96 || (_defs96 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000047040631693463884120000010788404834410650273_",
    d: "M130,121.9c4.4-4.5,8.1-9.8,10.7-15.6l-1.2-0.5 c-2.6,5.7-6.2,10.9-10.6,15.3L130,121.9z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052800057820048715140000006585045838434577840_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047040631693463884120000010788404834410650273_",
    style: {
      overflow: "visible",
      fill: "#808080"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137094057348493803800000005132721490017208213_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052800057820048715140000006585045838434577840_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026123050123182802830000012315373798682044607_",
    style: {
      clipPath: "url(#SVGID_00000137094057348493803800000005132721490017208213_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047040631693463884120000010788404834410650273_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026123050123182802830000012315373798682044607_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs97 || (_defs97 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000057106477191091746330000007208812401192453257_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000091012233944293971590000006147414533569504649_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000057106477191091746330000007208812401192453257_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 108.1,
    y: 105.2,
    style: {
      clipPath: "url(#SVGID_00000091012233944293971590000006147414533569504649_)",
      fill: "#808080"
    },
    width: 33.6,
    height: 31.6
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs98 || (_defs98 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000171718775131141166250000010183012660237218991_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174599139563471981800000009441278907733695152_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000171718775131141166250000010183012660237218991_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000174599139563471981800000009441278907733695152_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs99 || (_defs99 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000022555255203729038910000008756702497906477962_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000156555543828899132140000015818003878316647592_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000022555255203729038910000008756702497906477962_",
    style: {
      overflow: "visible"
    }
  })))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs100 || (_defs100 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054948315216179175610000011816654260071902603_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023980391163401515980000003866474320355335840_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054948315216179175610000011816654260071902603_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023980391163401515980000003866474320355335840_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs101 || (_defs101 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000121242356232683471740000011810889992170754177_",
    d: "M98.1,138.4l-0.2-1.3 c-5.6,0.8-11.5,0.8-17.1-0.1l-0.2,1.3c3,0.5,6,0.7,9,0.7C92.5,139.1,95.3,138.9,98.1,138.4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000095311844690467532920000009680951278787899559_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000121242356232683471740000011810889992170754177_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000095311844690467532920000009680951278787899559_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs102 || (_defs102 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000127024757024421098860000014358353132565749947_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080910381477254106580000017978810708945430660_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000127024757024421098860000014358353132565749947_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 79.6,
    y: 136.1,
    style: {
      clipPath: "url(#SVGID_00000080910381477254106580000017978810708945430660_)",
      fill: "#808080"
    },
    width: 19.5,
    height: 4
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs103 || (_defs103 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000147919742298886688950000011552880594840227200_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000166647259537115938320000016047019227093809580_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000147919742298886688950000011552880594840227200_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000166647259537115938320000016047019227093809580_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs104 || (_defs104 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000099663391098960817070000003784585154560390535_",
    d: "M89.6,138.5c-2.8,0-5.6-0.2-8.4-0.6v-0.2 c2.7,0.4,5.6,0.6,8.4,0.6c2.6,0,5.3-0.2,7.8-0.5v0.2C94.9,138.4,92.3,138.5,89.6,138.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042711057073030162550000005274659664295163294_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000099663391098960817070000003784585154560390535_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000042711057073030162550000005274659664295163294_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs105 || (_defs105 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000155140841431034386350000013474316044512610945_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000162317759010705297460000015666448685333277623_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000155140841431034386350000013474316044512610945_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 80.2,
    y: 136.7,
    style: {
      clipPath: "url(#SVGID_00000162317759010705297460000015666448685333277623_)",
      fill: "#808080"
    },
    width: 18.3,
    height: 2.8
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs106 || (_defs106 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000082335404231106836520000007100097196836066214_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000010303971145490277440000017576680144062822551_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000082335404231106836520000007100097196836066214_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs107 || (_defs107 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000051382746343939565850000008136447488375473033_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000002376594185612902790000012958370430235607972_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051382746343939565850000008136447488375473033_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs108 || (_defs108 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000166665354018418835230000013265459441135226004_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134228974709807579550000010220414110411621557_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166665354018418835230000013265459441135226004_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs109 || (_defs109 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000010291471652669438520000014585247568580508051_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131326518270140626110000000828811313678980744_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000010291471652669438520000014585247568580508051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131326518270140626110000000828811313678980744_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs110 || (_defs110 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000003824638521332524990000012471954031927716762_",
    d: "M149.5,70.1c0,4.1,3.3,7.4,7.3,7.4 s7.3-3.3,7.3-7.4s-3.3-7.3-7.3-7.3S149.5,66,149.5,70.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005968273753861778390000000944972233263906451_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003824638521332524990000012471954031927716762_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005968273753861778390000000944972233263906451_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs111 || (_defs111 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000173849044776390714070000007695873003968641925_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101097620633648238980000016751187072291973525_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173849044776390714070000007695873003968641925_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000101097620633648238980000016751187072291973525_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 2.5184,
      strokeMiterlimit: 10
    },
    cx: 156.8,
    cy: 70.1,
    rx: 7.3,
    ry: 7.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs112 || (_defs112 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176042666707521679540000012878650342401738393_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013163942322139633730000018117285510254547118_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176042666707521679540000012878650342401738393_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013163942322139633730000018117285510254547118_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs113 || (_defs113 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000110471979345201871900000011267198562497789056_",
    d: "M15.2,70.1c0,4.1,3.3,7.4,7.3,7.4 s7.3-3.3,7.3-7.4s-3.3-7.3-7.3-7.3S15.2,66,15.2,70.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000034083369962086392500000009791220796927052457_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000110471979345201871900000011267198562497789056_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000034083369962086392500000009791220796927052457_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs114 || (_defs114 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000072987557623447636730000013167537564974689209_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131340930153171253980000013545429601437735081_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000072987557623447636730000013167537564974689209_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000131340930153171253980000013545429601437735081_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 2.5184,
      strokeMiterlimit: 10
    },
    cx: 22.5,
    cy: 70.1,
    rx: 7.3,
    ry: 7.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs115 || (_defs115 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000071542320658971077090000007251749881918811273_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105389923487979443340000002701375453007916417_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071542320658971077090000007251749881918811273_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105389923487979443340000002701375453007916417_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs116 || (_defs116 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000018234429802068491310000015012920465970883519_",
    d: "M8.9,100c0,4.1,3.3,7.4,7.3,7.4 c4.1,0,7.3-3.3,7.3-7.4s-3.3-7.3-7.3-7.3C12.2,92.6,8.9,95.9,8.9,100z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000063605093080406370650000005259314352806747536_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000018234429802068491310000015012920465970883519_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000063605093080406370650000005259314352806747536_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs117 || (_defs117 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000064338652944220904700000000680841677738287756_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000041279613637238447420000000290815741550193842_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000064338652944220904700000000680841677738287756_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000041279613637238447420000000290815741550193842_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 2.5184,
      strokeMiterlimit: 10
    },
    cx: 16.2,
    cy: 100,
    rx: 7.3,
    ry: 7.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs118 || (_defs118 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000123429961584345286030000017345584679510393478_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163785931241218538500000001919242828597252758_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123429961584345286030000017345584679510393478_",
    style: {
      overflow: "visible"
    }
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs119 || (_defs119 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036959427533933702330000009895169879691307958_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000032648831870153091320000008846787060323683760_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036959427533933702330000009895169879691307958_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000032648831870153091320000008846787060323683760_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs120 || (_defs120 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000182517100179617213130000007926107254108384437_",
    cx: 162.6,
    cy: 100,
    r: 7.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000068651771232256520140000007578759554793066169_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182517100179617213130000007926107254108384437_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000068651771232256520140000007578759554793066169_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs121 || (_defs121 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000054949972879920467750000011240816800228169602_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000117673559148674376140000016208594907002491575_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054949972879920467750000011240816800228169602_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000117673559148674376140000016208594907002491575_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 2.5184,
      strokeMiterlimit: 10
    },
    cx: 162.6,
    cy: 100,
    rx: 7.3,
    ry: 7.3
  }))))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs122 || (_defs122 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000159457892269075299650000001356906110292718254_",
    x: -3.4,
    y: 36.3,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176746823536974475850000001583941033109517754_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159457892269075299650000001356906110292718254_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000176746823536974475850000001583941033109517754_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs123 || (_defs123 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000076580428530504461040000012136298013569094307_",
    cx: 150.3,
    cy: 126.5,
    r: 7.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014636439126373363770000002304061878120289967_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076580428530504461040000012136298013569094307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014636439126373363770000002304061878120289967_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs124 || (_defs124 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000168114919195716605740000010412500735711232689_",
    x: -13.4,
    y: 26.3,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000176038757273064210440000004558659747024768409_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168114919195716605740000010412500735711232689_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_00000176038757273064210440000004558659747024768409_)",
      fill: "none",
      stroke: "#808080",
      strokeWidth: 2.5184,
      strokeMiterlimit: 10
    },
    cx: 150.3,
    cy: 126.5,
    rx: 7.3,
    ry: 7.3
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    className: "st120"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs125 || (_defs125 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000150103813739224425950000002994385780140887733_",
    x: 8.9,
    y: 9.8,
    width: 162,
    height: 145
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015317163314314443530000018064641977310793378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000150103813739224425950000002994385780140887733_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015317163314314443530000018064641977310793378_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs126 || (_defs126 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000006703984139019637050000014815177275956998299_",
    d: "M128.4,85.5h-18.2c-0.3,0-0.5,0.1-0.7,0.3 l-5.9,6.4l-4.7-19.5c-0.1-0.4-0.4-0.7-0.8-0.7s-0.8,0.2-0.9,0.6l-4.9,11.9l-3.6-4.6c-0.2-0.3-0.6-0.4-0.9-0.4 c-0.3,0.1-0.6,0.3-0.7,0.6l-4.5,14.1l-5.9-26.6c-0.1-0.4-0.4-0.7-0.8-0.7s-0.8,0.2-0.9,0.6l-7.1,17.9h-4.8 c0-0.2,0-0.4-0.1-0.5c-2.1-3.3-3-7.2-2.6-11.1s2.2-7.5,4.9-10.3c3.2-3.2,7.6-5,12.1-5c4.6,0,8.9,1.8,12.1,5 c0.7,0.7,1.9,0.7,2.7,0c3.8-3.8,9-5.6,14.3-4.9s9.9,3.7,12.6,8.3s3.1,10.2,1.1,15.1c-0.1,0.2-0.2,0.5-0.1,0.8 s0.3,0.5,0.5,0.6c0.3,0.1,0.5,0.1,0.8,0c0.2-0.1,0.4-0.4,0.5-0.6c2.1-5.5,1.6-11.6-1.3-16.7c-3-5.1-8.1-8.4-14-9.2 c-5.8-0.7-11.7,1.3-15.8,5.4c-3.6-3.6-8.4-5.6-13.5-5.6c-5,0-9.9,2-13.5,5.6c-3,3-4.9,6.9-5.4,11.1s0.4,8.5,2.5,12.1h-8 c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h15.4c0.4,0,0.7-0.2,0.9-0.6l6.1-15.6L81.4,98c0.1,0.4,0.5,0.7,0.9,0.7 s0.8-0.3,0.9-0.7l5.1-15.7l3.5,4.5c0.2,0.3,0.5,0.4,0.9,0.4c0.3,0,0.6-0.3,0.8-0.6l4.4-10.7l4.4,18.3 c0.1,0.3,0.3,0.6,0.7,0.7c0.3,0.1,0.7,0,0.9-0.3l6.8-7.4h6.2l-26.1,26.1L66.4,88.9c-0.2-0.2-0.4-0.3-0.7-0.3 c-0.2,0-0.5,0.1-0.7,0.3c-0.4,0.4-0.4,1,0,1.3l25.1,25.1c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.5-0.1,0.7-0.3l28-28l0.1-0.1h9 c0.5,0,0.9-0.4,0.9-0.9C129.3,85.9,128.9,85.5,128.4,85.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000079470415131901723220000006229687000953395383_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006703984139019637050000014815177275956998299_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000079470415131901723220000006229687000953395383_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs127 || (_defs127 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000108276896603831210730000005797382223509676941_",
    x: -1.1,
    y: -0.2,
    width: 181,
    height: 165
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000163773354889635419480000010932673915844120462_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000108276896603831210730000005797382223509676941_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 50.9,
    y: 55.2,
    style: {
      clipPath: "url(#SVGID_00000163773354889635419480000010932673915844120462_)",
      fill: "#808080"
    },
    width: 79.4,
    height: 61.7
  })))))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionsHeart);
export default __webpack_public_path__ + "static/media/Connections-heart.16af2e9d3ddf90dd0e5e200546639f35.svg";
export { ForwardRef as ReactComponent };